export enum IbexaImageVariations {
  ArticleLarge = 'article_large',
  Article1024 = 'article_1024',
  Article780 = 'article_780',
  FullWidth = 'fullwidth',
  Large = 'large',
  Small = 'small',
  Tiny = 'tiny',
  Thumbnail = 'thumbnail',
  ThumbnailLarge = 'thumbnail_large',
  BannerLarge = 'banner_large',
}

export default IbexaImageVariations